import { store, itiHttpService} from '@/iti-core-vue';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { API } from '@/shared/api';
import { Post } from '@/shared/dtos/post';

@Module({
  namespaced: true,
  name: 'PostModule',
  store,
  dynamic: true,
})
class PostModule extends VuexModule {

    public posts: Post[] = [];
    public postsSearched: Post[] = [];
    public postsResume: Post[] = [];
    public post!: Post;  
    public editPost: Post = new Post();

    @Mutation
    public setPosts(posts: Post[]) {
        this.posts = posts;
        this.postsSearched = posts;
    }

    @Action
    public async getPosts(id: number) {
        const res = await itiHttpService.get(API.posts + '/Get?ambitId=' + id);
        this.context.commit('setPosts', res);
    }

    @Mutation
    public setPost(post: Post) {
        this.post = post;
    }

    @Action
    public async getPost(id: number) {
        return await itiHttpService.get(API.posts + '/GetPost?id=' + id);
    }

    @Action
    public async savePost(post: Post) {
        post.id = 0;
        this.posts.push(post);
        return await itiHttpService.post(API.posts, post.toJson());
    }

    @Mutation
    public setPostsSearched(posts: Post[]) {
        this.postsSearched = posts;
    }

    @Action
    public async filterPosts(text: string) {
        var postsSearch = this.posts.filter((post: Post) => 
            post.title.toLowerCase().includes(text.toLowerCase()) 
            || post.content.toLowerCase().includes(text.toLowerCase()));
        this.context.commit('setPostsSearched', postsSearch);
    }

    @Action
    public async deletePost(id: number) {
        this.posts.splice(this.posts.findIndex((post: Post) => post.id == id), 1);
        return await itiHttpService.delete(API.posts + '/Delete?id=' + id,'');
    }

    @Mutation
    public setEditPost(posts: Post) {
        this.editPost = posts;
    }

    @Action
    public async postToEdit(post: Post) {
        this.context.commit('setEditPost', post);
    }

    @Action
    public async updatePost(post: Post) {
        return await itiHttpService.put(API.posts,post.toJson());
    }

    @Mutation
    public setPostResume(posts: Post[]) {
        this.postsResume = posts;
    }

    @Action
    public async getPostResume(id: number) {
        var res =  await itiHttpService.get(API.posts + '/GetResume?ambitId=' + id);
        this.context.commit('setPostResume', res);
    }

}
export default getModule(PostModule);
